<template>
  <div class="page">
    <a-card title="基础信息" :bordered="false" :bodyStyle="{paddingTop:'10px'}"
            :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="酒店名称" prop="name">
          <a-input v-model="ruleForm.name" allow-clear :maxLength="16" placeholder="请输入" style="max-width: 500px;"/>
        </a-form-model-item>
        <a-form-model-item label="酒店地址" prop="address">
          <a-input v-model="ruleForm.address" allow-clear :maxLength="30" placeholder="请输入"
                   style="max-width: 500px;"/>
        </a-form-model-item>
        <a-form-model-item label="客服电话" prop="phone">
          <a-input v-model="ruleForm.phone" allow-clear :maxLength="15" placeholder="请输入" style="max-width: 500px;"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存设置</a-button>
          <a-button @click="resetFormData">重置</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import ruleFormLayout from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'HotelMemberInfo',
  mixins: [ruleFormLayout],
  components: {},
  data() {
    return {
      submitLoading: false,
      accountId: 0,
      myAccountId: 0,
      ruleForm: {
        name: '',
        address: '',
        phone: ''
      },
      roleList: [],
      destinationList: [],
      rules: {
        name: [
          { required: true, message: '请输入酒店名称', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入酒店地址', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入客服电话', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'HotelMemberList', title: '权益列表' },
      { name: 'HotelMemberInfo', title: '基础信息' }
    ])
    this.getHotelInfo()
  },
  methods: {
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitData() {
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitLoading = true
      this.getHttpServices().getCouponService().post('rights/editHotelInfo', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('基础信息保存成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取信息
    getHotelInfo() {
      this.getHttpServices().getCouponService().get('rights/getHotelInfo').then(res => {
        this.getLogUtils().logWithTag('getAccountInfo', res)
        if (res && res.name) {
          this.ruleForm = res
        } else {
          this.resetFormData()
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    resetFormData() {
      this.ruleForm = {
        name: '',
        address: '',
        phone: ''
      }
    }
  }
}
</script>
<style scoped lang="less">
.ant-btn + .ant-btn {
  margin-left: 10px;
}

.span-right {
  padding-left: 10px;
}
</style>